export default __webpack_public_path__ + "static/media/light_circle_1.d9842b8c.png";